__turbopack_context__.v({
  "error": "items-form-block1440px-module-scss-module__ZmaftW__error",
  "errorText": "items-form-block1440px-module-scss-module__ZmaftW__errorText",
  "formblock": "items-form-block1440px-module-scss-module__ZmaftW__formblock",
  "icon": "items-form-block1440px-module-scss-module__ZmaftW__icon",
  "icon5": "items-form-block1440px-module-scss-module__ZmaftW__icon5",
  "interestedInSponsorship": "items-form-block1440px-module-scss-module__ZmaftW__interestedInSponsorship",
  "item1": "items-form-block1440px-module-scss-module__ZmaftW__item1",
  "item11": "items-form-block1440px-module-scss-module__ZmaftW__item11",
  "item2": "items-form-block1440px-module-scss-module__ZmaftW__item2",
  "items": "items-form-block1440px-module-scss-module__ZmaftW__items",
  "label": "items-form-block1440px-module-scss-module__ZmaftW__label",
  "leftcol": "items-form-block1440px-module-scss-module__ZmaftW__leftcol",
  "lookingForA": "items-form-block1440px-module-scss-module__ZmaftW__lookingForA",
  "lookingformblock1440px": "items-form-block1440px-module-scss-module__ZmaftW__lookingformblock1440px",
  "raceTeamImage": "items-form-block1440px-module-scss-module__ZmaftW__raceTeamImage",
  "rightcol": "items-form-block1440px-module-scss-module__ZmaftW__rightcol",
  "row": "items-form-block1440px-module-scss-module__ZmaftW__row",
  "tellUsWhat": "items-form-block1440px-module-scss-module__ZmaftW__tellUsWhat",
  "tellUsWhatContainer": "items-form-block1440px-module-scss-module__ZmaftW__tellUsWhatContainer",
  "text": "items-form-block1440px-module-scss-module__ZmaftW__text",
  "text1": "items-form-block1440px-module-scss-module__ZmaftW__text1",
  "text6": "items-form-block1440px-module-scss-module__ZmaftW__text6",
  "textField": "items-form-block1440px-module-scss-module__ZmaftW__textField",
  "textFieldsWrapper": "items-form-block1440px-module-scss-module__ZmaftW__textFieldsWrapper",
  "wrapper": "items-form-block1440px-module-scss-module__ZmaftW__wrapper",
});
